<template>
  <section class="map">
    <div id="map" />
    <section class="healthy-warning">
      <van-tabs v-model="active" :line-width="30" :line-height="2" title-active-color="#2a9cf2" color="#2a9cf2" @click="tabClick">
        <van-tab title="未处理" />
        <van-tab title="已提醒" />
      </van-tabs>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="tips"
        class="listbox"
        @load="getList"
      >
        <van-swipe-cell v-for="(item,index) in list" :key="index" class="unresolve">
          <van-cell-group @click="setMarket(index)">
            <div class="sosItem">
              <img v-lazy="item.headUrl" class="images">
              <div class="content">
                <div class="user">
                  <p>{{ item.name }}</p>
                  <p class="main">
                    {{ item.testTime }}
                  </p>
                </div>
                <div class="time">
                  求救位置：经度：{{ item.lat }}&nbsp; 纬度{{ item.lng }}

                </div>
              </div>
            </div>
          </van-cell-group>
        </van-swipe-cell>
      </van-list>
    </section>
  </section>

</template>
<script>
import { healthSos } from '@/api/health-sos'
import { Loader } from 'google-maps'
// or const {Loader} = require('google-maps'); without typescript

export default {
  data() {
    return {
      center: { lat: 39, lng: 116 },
      zoom: 15,
      map: null,
      marker: null,
      active: 0,
      show: false,
      list: [],
      params: {
        page: 1,
        row: 20,
        accountId: 1,
        ishandle: false
      },
      loading: false,
      finished: false,
      tips: '',
      options: {}
    }
  },
  mounted() {
    this.marketFun()
  },
  methods: {
    positionHandle() {
      this.$toast.loading({
        message: '正在寻址',
        duration: 0
      })
    },
    tabClick(value) {
      this.params.page = 1
      switch (value) {
        case 0:
          this.params.ishandle = false
          this.getList()
          break
        case 1:
          this.params.ishandle = true
          this.getList()
          break
      }
    },
    marketFun() {
      this.options = {
        zoom: 10,
        center: { lat: 39, lng: 116 },
        disableDefaultUI: false,
        scaleControl: false,
        rotateControl: false,
        language: 'zh'
      }
      /* eslint-disable */
      var a = new Loader('AIzaSyBniKj4eAshfmNsuF9x1MgsUu4GO8ipPFY', this.options).load().then(google => {
        this.map = new google.maps.Map(document.getElementById('map'), this.options)
        this.marker = new google.maps.Marker(
          {
            position: { lat: 39, lng: 116 },
            map: this.map,
            label: '1',
            draggable: false,
            title: 'Drag me!'
          }
        )
        this.marker.addListener('click', this.setMarket)
      })
      /* eslint-disable */
    },
    async getList() {
      // this.params.accountId = this.$route.query.id
      try {
        const res = await healthSos(this.params)
        const list = res.data.data
        if (this.params.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        console.log(this.list)
        this.loading = false
        this.tips = this.list.length ? this.$t('viewBase.a46') : this.$t('viewBase.a47')
        this.finished = list.length < 20
        this.params.page++
      } catch (error) {
        console.log(error)
      }
    },
    setMarket(index) {
      console.log(this.list[index])
      var item = this.list[index]
      this.options = {
        zoom: 13,
        center: { lat: item.lat, lng: item.lng },
        disableDefaultUI: false,
        scaleControl: false,
        rotateControl: false,
        language: 'zh'
      }
      // this.map = new google.maps.Map(document.getElementById('map'), options)
      this.marker.setPosition({ lat: item.lat, lng: item.lng })
      /* eslint-disable */
      this.marker.setMap(new google.maps.Map(document.getElementById('map'), this.options))
      /* eslint-disable */
      this.marker.setLabel(item.name)
    }
  }
}
</script>
<style scoped lang="scss">
.map{
  width: 100%;
  height: calc( 100vh - 42px);
  overflow: hidden;
  position: fixed;
  bottom: 0;
}
#map{height:500px;width:100%;}
.tabs {
  position: fixed;
  top: 10vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  background: #fff;
  color: #666;
  font-size: 12px;
  border-radius: 20px;
  .tab {
    width: 80px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    position: relative;
  }
  .tab:nth-child(1)::after {
    content: '|';
    color: #bbb;
    position: absolute;
    right: 0;
  }
  .active {
    color: #1989fa;
  }
}
.curr-address {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 15px;
  background: #fff;
  border-radius: 15px 15px 0 0;
}
.positon {
  position: absolute;
  top: 50%;
  right: 15px;
  z-index: 100;
  font-size: 28px;
  background: #fff;
  color: #1989fa;
  padding: 6px 6px 4px;
  border: 1px solid #ececec;
  border-radius: 5px;
  box-shadow: 2px 2px 5px #ececec;
  text-align: center;
  .icon {
    display: block;
  }
  .text {
    font-size: 12px;
    color: #666;
    line-height: 1.8;
    transform: scale(.8);
    margin-top: -10px;
  }
}
.handle {
    background: #bbb;
    color: #fff;
    text-align: center;
    height:111%;
    display: flex;
    justify-content: center;
    align-items: center;
}
[class*=van-hairline]::after{
  border:none!important;
}
</style>

<style lang="scss">
  .mapPopup {
    border-radius: 15px 15px 0 0;
    height: 75vh;
  }
  .map-addresss {
    padding: 10px 15px;
  }
  .map-address {
    text-align: left;
    padding: 10px 0;
    border-bottom: 1px solid #ececec;
    .time {
      font-size: 12px;
      color: #666;
    }
    .desc {
      font-size: 15px;
      margin-top: 5px;
      color:#000;
    }
    .meta {
      font-size: 12px;
      color: #666;
      margin-top: 10px;
    }
  }
  .map-address:nth-last-of-type(1) {
    border: none;
  }
</style>
<style scoped lang="scss">
.unresolve {
  .van-swipe-cell__right {
    color: #fff;
    font-size: 15px;
    width: 65px;
    height: 80px;
    display: inline-block;
    text-align: center;
    line-height: 80px;
    background-color: #f44;
  }
  .van-swipe-cell__left {
    color: #fff;
    font-size: 15px;
    width: 65px;
    height: 88px;
    display: inline-block;
    text-align: center;
    line-height: 88px;
    background-color: #0066ff;
  }
}
.sosItem{
  width: 100%;
  padding:15px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  .content{
    width: 100%;
    .user{
      width: 100%;
      display:flex;
      justify-content: space-between;
    }
    p{
      text-align: left;
      color:#333;
      font-size:14px;
      margin:5px 0 0;
    }
    .main{
      color:#999;
       font-size: 12px;
    }
    .time{
      color:#999;
       font-size: 12px;
       margin-top:7px;
       text-align: left;
    }
  }

}
.images{
  width:50px;
  height:50px;
  border-radius: 50%;
 margin-right:10px;
 flex:none;
}
.text{
  width:80%;
  border:1px solid #999;
  border-radius: 10px;
  height:auto;
  padding:15px;
  margin:15px auto;
}
.text1{
  padding:5px;
}
.handle {
    background: #ccc;
    color: #fff;
    text-align: center;
    // line-height: 81px;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.healthy-warning{
  height:400px;
   position: absolute;
  top: 400px;
}
.listbox{
  height:250px;
  overflow-y: auto;
}
</style>

